<template>
  <div class="absolute end-1.5 top-2.5 flex items-center text-xs text-wt-red-d">
    <i class="fa-solid fa-asterisk fa-2xs"></i>
  </div>
</template>
